<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Edit Time Based Subchannel
            </h3>

            <p>
              Edit the details of the time based subchannel.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the time based subchannel."
                    :error="(errors['name'] || [])[0]"
                />

                <ColorFormGroup
                    v-model="data.color"
                    name="color"
                    label="Color"
                    help-text="The color of the time based subchannel."
                    :error="(errors['color'] || [])[0]"
                    :colors="colors"
                />

                <SelectFormGroup
                    v-model="data.category"
                    name="category"
                    label="Time Subchannel Category"
                    :error="getError('category')"
                    :options="timeSubchannelCategoryOptions"
                />

                <RadioFormGroup
                    v-model="data.is_active"
                    name="is_active"
                    label="Active"
                    help-text="A flag indicating if the time based subchannel is active."
                    :error="(errors['is_active'] || [])[0]"
                    :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>

      <hr class="panel-separator">

      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Ad Formats
            </h3>

            <p>
              These are the ad formats that belong to the channel.
            </p>

            <router-link
                class="btn btn-black btn-sm"
                :to="'/portals/'+ portal.id + '/time-based-channels/' + timeBasedChannel.id + '/time-based-subchannels/' + timeBasedSubchannel.id + '/ad-formats/create'"
            >
              <i class="fa fa-plus"></i> New
            </router-link>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <TimeBasedAdFormatListPanel
              :portal="portal"
              :time-based-channel="timeBasedChannel"
              :time-based-subchannel="timeBasedSubchannel"
          />
        </div>
      </div>

      <hr class="panel-separator">

      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Budget
            </h3>

            <p>
              This table displays the budget for the channel.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <NewList
              label="Month"
              :targets="[{name: 'base', label: 'Target', width: 9}, {name: 'management', label: 'Management', width: 9}]"
              :endpoint="'/api/v2/time-based-subchannels/' + timeBasedSubchannel.id + '/targets'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NewList from '../../../../../components/Panels/Administration/Targets/NewList'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import ColorFormGroup from '@/components/FormGroups/Horizontal/Color'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import TimeBasedAdFormatListPanel from '@/components/Administration/TimeBasedAdFormats/Panels/List'

export default {
  components: {
    HelpText,
    LoadingContainer,
    NewList,
    RadioFormGroup,
    SubmitFormGroup,
    ColorFormGroup,
    SelectFormGroup,
    TextFormGroup,
    TimeBasedAdFormatListPanel,
  },

  mixins: [Errors],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'timeBasedChannelId', 'timeBasedSubchannelId'],

  data() {
    return {
      data: {},

      timeBasedChannel: null,
      timeBasedSubchannel: null,
      colors: null,
      timeSubchannelCategories:null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    timeSubchannelCategoryOptions() {
      return this.timeSubchannelCategories.map(timeSubchannelCategory => ({
        value: timeSubchannelCategory.id,
        label: timeSubchannelCategory.attributes.name
      }))
    }
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/time-based-channels/' + this.timeBasedChannelId),
        http.get('/api/v2/time-based-subchannels/' + this.timeBasedSubchannelId),
        http.get('/api/v2/colors'),
        http.get('/api/v2/time-subchannel-categories'),
      ]).then(responses => {
        this.timeBasedChannel = responses[0].data.data

        this.timeBasedSubchannel = responses[1].data.data

        this.data = {...this.timeBasedSubchannel.attributes}

        this.colors = responses[2].data.data

        this.timeSubchannelCategories = responses[3].data.data

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/time-based-subchannels/' + this.timeBasedSubchannel.id, this.data)
          .then(() => {
            notify.success('The time based subchannel was saved')

            this.errors = {}
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
